import { SimpleResumeManagerProvider } from './simple-resume-manager.provider';
import { SimpleResumeManager } from './simple-resume-manager.view';

export function FeatureSimpleResumeManager() {
   return (
      <SimpleResumeManagerProvider>
         <SimpleResumeManager />
      </SimpleResumeManagerProvider>
   );
}
